'use client';

import * as React from 'react';
import EmailTextInput from './fields/EmailTextInput';
import { useState } from 'react';
import Button from './Button';
import sendSignInLinkToEmail from '../helpers/auth/sendSignInLinkToEmail';
import logEvent from '../helpers/mutations/logEvent';
import {
  AnalyticsEventAction,
  AnalyticsEventType,
} from '@th/shared/src/types/AnalyticsEvent';
import emailValidator from '@th/shared/src/validators/emailValidator';
import { useSearchParams } from 'next/navigation';

type Props = {};

export default function SigninCard({}: Props) {
  const [step, setStep] = useState<'signin' | 'check_email'>('signin');
  const [email, setEmail] = useState('');
  const [showInvalid, setShowInvalid] = useState(false);
  const params = useSearchParams();
  const agentSlug = params.get('agentSlug') || null;

  async function validateAndSubmit() {
    logEvent({
      action: AnalyticsEventAction.clicked_signup_button_in_signin_card,
      type: AnalyticsEventType.signup_button_click,
    });
    const isEmailValid = emailValidator.required().isValidSync(email);
    if (isEmailValid) {
      await sendSignInLinkToEmail(email, agentSlug);
      setStep('check_email');
    } else {
      setShowInvalid(true);
    }
  }

  function updateEmail(email) {
    setShowInvalid(false);
    setEmail(email);
  }

  return (
    <div className="flex flex-col bg-background p-6 border rounded-lg shadow-2xl">
      <h3 className="text-xl mb-8">Sign up</h3>
      {step === 'signin' && (
        <div className="flex flex-col flex-1">
          <EmailTextInput
            email={email}
            setEmail={updateEmail}
            showValid={true}
            showInvalid={showInvalid}
            label={'Email'}
            className="mb-6"
          />
          <Button title={'Sign up'} onClick={validateAndSubmit} />
        </div>
      )}
      {step === 'check_email' && (
        <div className="flex flex-col flex-1">
          <p className="text-secondaryText mb-6">
            We sent a sign in link to your email. Please check your inbox.
          </p>
        </div>
      )}
    </div>
  );
}
